import {useContext} from 'react';

import {UserContext} from './user-context';
import {UserContextType} from './user-context-type';

export function useUser(): UserContextType {
    return useContext<UserContextType>(UserContext);
}
